import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>SSD Linehaul Pending Induct</h2>
  <h3>Description</h3>
  <p>This disruption occurs when an outbound SSD truck has already been docked within the TDR process, but package induction has not begun.</p>
  <h3>SOP</h3>
  <ul>
    <li><b>At Risk (Yellow):</b> This proactive signal is to alert the site of the upcoming need to start inducting injection.</li>
    <li><b>Critical (Red):</b> Begin inducting injection right away and this exception will resolve.</li>
    <li><b>Late (Orange):</b> Fill out notes as to why Injection did not begin per the SOP and begin inducting injection.</li>
  </ul>
  <div>
    If this alert is active, the exception will resolve when 10% of the respective VRID has been inducted.
  </div>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_LINEHAUL_PENDING_INDUCT.jsx